
export const recapData = {
    intro: {
        title: "2025 in Review",
        subtitle: "Time to Review my past year",
    },
    months: [
        {
            month: "January",
            title: "Zoho Life",
            highlight: "2025 didn’t start with resolutions, it started with a Zoho performance bonus and recognition for last year’s work.",
            image: "https://analyticsindiamag.com/wp-content/uploads/2018/08/zoho-1.jpg",
            color: "#FF6B6B"
        },
        {
            month: "March",
            title: "Load Balancing",
            highlight: "Learning real-world balance, personally and professionally,while shipping load balancing at Zoho.",
            image: "https://www.godaddy.com/resources/in/wp-content/uploads/sites/13/2024/07/Web-hosting.jpg?size=3840x0",
            color: "#4ECDC4"
        },
        {
            month: "August",
            title: "Farewell Zoho",
            highlight: "Concluding a three year journey at Zoho, spending the final days wrapping up work and handovers.",
            image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1920&auto=format&fit=crop",
            color: "#FFE66D"
        },
        {
            month: "September",
            title: "Hello Dublin",
            highlight: "Dublin became home as I began my Master’s at the National College of Ireland.",
            image: "https://images.unsplash.com/photo-1554801790-808e40a34ce2?q=80&w=1625&auto=format&fit=crop",
            color: "#1A535C"
        },
        {
            month: "October",
            title: "GradIreland",
            highlight: "At the GradIreland event, I stopped guessing and started understanding what employers actually look for.",
            image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1920&auto=format&fit=crop",
            color: "#FF9F1C"
        },
        {
            month: "November",
            title: "Portfolio Shipped",
            highlight: "Took my portfolio off the shelf, removed the dust, and finally deployed what I’d been building all along.",
            image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?q=80&w=1920&auto=format&fit=crop",
            color: "#2E2E2E"
        }
    ],
    projects: [
        { name: "Portfolio", type: "Personal Website" },
        { name: "Silicon Feed", type: "AI Article Summarizer" },
        { name: "Job Tracker", type: "Job Application Tracker" },
    ],
    stats: {
        commits: 1243,
        hours: 2760,
        coffee: 400
    },
    summary: {
        title: "Happy New Year!",
        message: "Hoping to have a great year ahead."
    },
    backgrounds: {
        stats: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1920&auto=format&fit=crop" // Data/Charts
    }
};
